(function () {
  "use strict";

  SeriesCustomizeCtrl.$inject = ['$scope', '$rootScope', '$route', 'CustomizeResource', 'mtypes', 'trainerPrivilege', 'trackingService', '$window', '$location'];
  angular
    .module('trainerWebApp.controllers')
    .controller('SeriesCustomizeCtrl', SeriesCustomizeCtrl);

  function SeriesCustomizeCtrl($scope, $rootScope, $route, CustomizeResource, mtypes, trainerPrivilege, trackingService,
                               $window, $location) {

    var certificate = $scope.resolvedData.certificate;
    var courseShare = $scope.resolvedData.courseShare;
    var quizSettings = $scope.resolvedData.quizSettings;
    var courseDeadlineSettings = $scope.resolvedData.courseDeadlineSettings;
    var reTakeEnabled = $scope.resolvedData.reTakeEnabled;
    var sensionUsage = $scope.resolvedData.sensionUsage;
    var hasCustomCertificate = $scope.resolvedData.hasCustomCertificate;
    var triggerSave = false; //fix for bad data
    var userRole = trainerPrivilege.roles();

    $scope.resolvedData = null;
    $scope.model = {};

    $scope.courseDeadlineEnabledOptions = [
      {name: 'No Deadline', value: "no"},
      {name: 'Deadline', value: "yes"}
    ];

    $scope.allowCustomCertificate = !!~$window.mfConfig.features.indexOf(mtypes.featureEntry.customCertificate);

    $scope.certificates = [
      {template: mtypes.certificateTemplate.template1, index: '1', selected: ""},
      {template: mtypes.certificateTemplate.template2, index: '2', selected: ""},
      {template: mtypes.certificateTemplate.template3, index: '3', selected: ""}
    ];

    if ($scope.allowCustomCertificate) {
      $scope.certificates.push(
        {template: mtypes.certificateTemplate.custom, index: '4', selected: ""}
      )
    } else if (certificate.certificateTemplate == mtypes.certificateTemplate.custom) {
      certificate.certificateTemplate = mtypes.certificateTemplate.template1;
    }

    $scope.courseDeadlineUnits = [
      {id: mtypes.courseDeadlineUnit.day, name: "Day(s)"},
      {id: mtypes.courseDeadlineUnit.week, name: "Week(s)"}
    ];

    //check nulls and set defaults
    if (userRole.canEditCourses)
      certificateNullCheck();

    //set current values
    $scope.seriesId = $route.current.params.seriesId;
    $scope.certificateTemplate = certificate.certificateTemplate;
    $scope.certificateStatus = certificate.certificateStatus;
    $scope.certificateQuizStatus = certificate.certificateQuizStatus;

    $scope.hasPassingScore = quizSettings.hasPassingScore == 1;
    $scope.passingScore = quizSettings.passingScore;

    $scope.currentCertificatePath = "";

    $scope.hasDeadline = (courseDeadlineSettings.completionDeadlineLength != 0);

    if ($scope.hasDeadline) {
      $scope.courseDeadlineLength = courseDeadlineSettings.completionDeadlineLength;
      $scope.courseDeadlineUnit = courseDeadlineSettings.completionDeadlineTimeUnit;
    }
    else {
      $scope.courseDeadlineLength = 1;
      $scope.courseDeadlineUnit = mtypes.courseDeadlineUnit.week;
    }
    $scope.hasDeadlineText = $scope.hasDeadline ? "yes" : "no";

    $scope.courseDeadlineLengthText = $scope.courseDeadlineLength;
    setDeadlineEditorHelpText();

    if (certificate.certificateTemplate)
      setLargeImagePath(_.where($scope.certificates, {template: certificate.certificateTemplate})[0].index);

    $scope.certAfterIndividualCourses = false;
    $scope.certAfterSeries = false;
    $scope.certShowAggregateScores = false;
    setCertificateSettingBooleans();

    $scope.model.courseAccessTypes = [
      {
        mtype: mtypes.courseAccessType.teamMemberInviteOnly,
        text: 'Private',
        subtext: 'Trainees must be invited.'
      },
      {
        mtype: mtypes.courseAccessType.existingUserSelfRegister,
        text: 'Current Trainees',
        subtext: 'Existing trainees can enroll.'
      },
      {
        mtype: mtypes.courseAccessType.publicSelfRegister,
        text: 'Public',
        subtext: ' Anyone with a link can register.'
      }
    ];
    $scope.model.courseAccessType = courseShare.courseAccessType;
    $scope.showAccessTypeSettings = $scope.model.courseAccessType != mtypes.courseAccessType.noRegister;

    $scope.model.sensionUsages = [
      {
        mtype: mtypes.sensionUsage.none,
        text: 'Off'
      },
      {
        mtype: mtypes.sensionUsage.measureEngagement,
        text: 'Measure Engagement'
      },
      {
        mtype: mtypes.sensionUsage.requireEngagement,
        text: 'Require Engagement'
      }
    ];
    $scope.model.sensionUsage = sensionUsage;


    $scope.yammerSharesEnabled = courseShare.yammerSharesEnabled;
    $scope.coursePublicURL = courseShare.publicURL;
    $scope.description = courseShare.description;
    $scope.companyName = courseShare.companyName;
    $scope.trainerName = courseShare.trainerName;
    $scope.companyLogoUrl = courseShare.companyLogoUrl;
    $scope.mindflashLogoUrl = courseShare.mindflashLogoUrl;
    $scope.yammerUrl = courseShare.yammerUrl;
    $scope.reTakeEnabled = !!reTakeEnabled;
    $scope.hasSensionFeature = !!~$window.mfConfig.features.indexOf(mtypes.featureEntry.sension) || !!~$window.mfConfig.trialFeatures.indexOf(mtypes.featureEntry.sension);

    if (triggerSave)
      updateCertificateSettings();

    $scope.openModal = function () {
      if (!$scope.isPublicSeriesPageActive()) return;

      var params = {
        url: $scope.coursePublicURL,
        type: "series"
      };
      $rootScope.$broadcast('openShareUrlRequestedEvent', params);

      trackingService.trackEvent(
        trackingService.pages.seriesCustomize.name,
        trackingService.pages.seriesCustomize.actions.getUrlToShareSeries);
    };

    $scope.certificateSelect = function (certificate) {
      if (certificate.template == mtypes.certificateTemplate.custom) {
        $location.path('/TMS/Series/' + $scope.seriesId + '/customCertificate');
        return;
      }

      _.each($scope.certificates, function (cert) {
        cert.selected = ""
      });
      setLargeImagePath(certificate.index);
      certificate.certificateTemplate = _.where($scope.certificates, {index: certificate.index})[0].template;
      $scope.certificateTemplate = _.where($scope.certificates, {index: certificate.index})[0].template;
      updateCertificateSettings();

    };


    $scope.customCertificateSelected = function () {
      return $scope.certificateTemplate == mtypes.certificateTemplate.custom;
    };

    function setLargeImagePath(index) {
      var ext = index != 4 ? '.jpg' : '.png';
      $scope.currentCertificatePath = '/Trainer/images/certificates/cert_style_' + index + '_series' + ext;
      $scope.certificates[index - 1].selected = "-selected";
    }

    $scope.getSmallImagePath = function (certificate) {
      // hasCustomCertificate
      if (certificate.index == 4 && !hasCustomCertificate) {
        return '/Trainer/images/certificates/cert_style_' + certificate.index + '_small.png';
      }
      return '/Trainer/images/certificates/cert_style_' + certificate.index + '_small_series.png';
    };


    function setCertificateSettingBooleans() {

      switch (certificate.certificateStatus) {
        case mtypes.certificateStatus.afterSeriesAndCourses:
          $scope.certAfterIndividualCourses = true;
          $scope.certAfterSeries = true;
          break;
        case mtypes.certificateStatus.afterSeriesOnly:
          $scope.certAfterSeries = true;
          break;
        case mtypes.certificateStatus.afterCoursesOnly:
          $scope.certAfterIndividualCourses = true;
          break;
      }
      $scope.certShowAggregateScores = (certificate.certificateQuizStatus == mtypes.certificateQuizStatus.on);
    }


    $scope.setCertificateStatusBooleans = function (controlId) {

      if ($scope.certAfterIndividualCourses == true) {
        if ($scope.certAfterSeries == true)
          $scope.certificateStatus = mtypes.certificateStatus.afterSeriesAndCourses;
        else
          $scope.certificateStatus = mtypes.certificateStatus.afterCoursesOnly;
      } else {
        if ($scope.certAfterSeries == true)
          $scope.certificateStatus = mtypes.certificateStatus.afterSeriesOnly;
        else
          $scope.certificateStatus = mtypes.certificateStatus.off;
      }
      updateCertificateSettings();

      if (controlId) {
        switch (controlId) {
          case "cert-after-individual-courses" :
            trackingService.trackEvent(
              trackingService.pages.seriesCustomize.name,
              trackingService.pages.seriesCustomize.actions.issueCertificatesPerCourse);
            break;
          case "cert-after-series" :
            trackingService.trackEvent(
              trackingService.pages.seriesCustomize.name,
              trackingService.pages.seriesCustomize.actions.issueCertificatesForSeries);
            break;
        }
      }
    };

    $scope.setAggregateScore = function () {
      if ($scope.certShowAggregateScores)
        $scope.certificateQuizStatus = mtypes.certificateQuizStatus.on;
      else
        $scope.certificateQuizStatus = mtypes.certificateQuizStatus.off;
      updateCertificateSettings();
    };

    $scope.setCertificateQuizStatus = function () {
      if ($scope.certShowAggregateScores)
        $scope.certificateQuizStatus = mtypes.certificateQuizStatus.on;
      else
        $scope.certificateQuizStatus = mtypes.certificateQuizStatus.off;
      updateCertificateSettings();

      trackingService.trackEvent(
        trackingService.pages.seriesCustomize.name,
        trackingService.pages.seriesCustomize.actions.showSeriesScoreOnCertificates);
    };

    function updateCertificateSettings() {
      CustomizeResource.updateCertificateSettings(
        $scope.seriesId,
        $scope.certificateStatus,
        $scope.certificateQuizStatus,
        $scope.certificateTemplate,
        function () {
          $scope.infoChanged = false;
        });
    }

    function certificateNullCheck() {

      if (certificate.certificateTemplate == 0) {
        certificate.certificateTemplate = mtypes.certificateTemplate.template1;
        triggerSave = true;
      }
      if (certificate.certificateStatus == 0) {
        certificate.certificateStatus = mtypes.certificateStatus.afterSeriesAndCourses;
        triggerSave = true;
      }
      if (certificate.certificateQuizStatus == 0) {
        certificate.certificateQuizStatus = mtypes.certificateQuizStatus.on;
        triggerSave = true;
      }
    }

    $scope.passingScoreSettingsChanged = function () {
      var num = parseInt($scope.passingScore);
      if (isNaN(num)) {
        $scope.passingScore = "";
        return;
      }
      $scope.passingScore = num;
      if (num < 0)
        $scope.passingScore = 0;
      if (num > 100)
        $scope.passingScore = 100;

      updatePassingScoreSettings();

      trackingService.trackEvent(
        trackingService.pages.seriesCustomize.name,
        trackingService.pages.seriesCustomize.actions.passingScore);
    };

    function updatePassingScoreSettings() {
      CustomizeResource.updateCoursePassingScoreSettings(
        $scope.seriesId,
        $scope.hasPassingScore,
        $scope.passingScore,
        function () {
          $scope.infoChanged = false;
        });
    }

    $scope.reTakeEnabledChanged = function () {
      CustomizeResource.updateCourseRetakeEnabled(
        $scope.seriesId,
        $scope.reTakeEnabled,
        function () {
          $scope.infoChanged = false;
        });

      trackingService.trackEvent(
        trackingService.pages.seriesCustomize.name,
        trackingService.pages.seriesCustomize.actions.retakeEnabled);
    };

    $scope.updateSensionUsage = function () {
      CustomizeResource.updateSensionUsage(
        $scope.seriesId,
        $scope.model.sensionUsage,
        function () {
          $scope.infoChanged = false;
        });

      trackingService.trackEvent(
        trackingService.pages.seriesCustomize.name,
        trackingService.pages.seriesCustomize.actions.updateSensionUsage);
    };

    $scope.updateAccessType = function () {
      updateCourseShareSettings();

      trackingService.trackEvent(
        trackingService.pages.seriesCustomize.name,
        trackingService.pages.seriesCustomize.actions.updateAccessType);
    };

    $scope.isPublicSeriesPageActive = function () {
      return $scope.model.courseAccessType != mtypes.courseAccessType.teamMemberInviteOnly;
    };

    $scope.getShareSeriesLinkClass = function () {
      return $scope.isPublicSeriesPageActive() ? '' : 'disabled';
    };

    $scope.yammerSharesEnabledChanged = function () {
      updateCourseShareSettings();

      trackingService.trackEvent(
        trackingService.pages.seriesCustomize.name,
        trackingService.pages.seriesCustomize.actions.yammerSharesEnabledChanged);
    };

    $scope.shareToEmail = function ($shareEvent) {
      if (!$scope.isPublicSeriesPageActive()) return;

      $shareEvent.type = 'email';
      $shareEvent.url = $scope.coursePublicURL;
      $shareEvent.description = $scope.description ? $scope.description : "";
      $shareEvent.companyName = $scope.companyName;
      $shareEvent.trainerName = $scope.trainerName;
      $shareEvent.title = $scope.title.seriesTitle;

      trackingService.trackEvent(
        trackingService.pages.seriesCustomize.name,
        trackingService.pages.seriesCustomize.actions.emailLinkToSeries);
    };

    $scope.shareToFacebook = function ($shareEvent) {
      if (!$scope.isPublicSeriesPageActive()) return;

      $shareEvent.type = 'facebook';
      $shareEvent.url = $scope.coursePublicURL;
      $shareEvent.description = $scope.description ? $scope.description : "";
      $shareEvent.title = $scope.title.seriesTitle;
      $shareEvent.companyLogoURL = $scope.companyLogoUrl; // TBD
      $shareEvent.mindflashLogoURL = $scope.mindflashLogoUrl;

      trackingService.trackEvent(
        trackingService.pages.seriesCustomize.name,
        trackingService.pages.seriesCustomize.actions.shareToFacebook);
    };

    $scope.shareToLinkedIn = function ($shareEvent) {
      if (!$scope.isPublicSeriesPageActive()) return;

      $shareEvent.type = 'linkedin';
      $shareEvent.url = $scope.coursePublicURL;
      $shareEvent.title = $scope.title.seriesTitle;

      trackingService.trackEvent(
        trackingService.pages.seriesCustomize.name,
        trackingService.pages.seriesCustomize.actions.shareToLinkedin);
    };

    $scope.shareToTwitter = function ($shareEvent) {
      if (!$scope.isPublicSeriesPageActive()) return;

      $shareEvent.type = 'twitter';
      $shareEvent.url = $scope.coursePublicURL;
      $shareEvent.companyName = $scope.companyName;
      $shareEvent.title = $scope.title.seriesTitle;
      $shareEvent.objectId = $scope.seriesId;

      trackingService.trackEvent(
        trackingService.pages.seriesCustomize.name,
        trackingService.pages.seriesCustomize.actions.shareToTwitter);
    };

    $scope.shareToYammer = function ($shareEvent) {
      if (!$scope.isPublicSeriesPageActive()) return;

      $shareEvent.type = 'yammer';
      $shareEvent.url = $scope.coursePublicURL;
      $shareEvent.yammerUrl = $scope.yammerUrl;

      trackingService.trackEvent(
        trackingService.pages.seriesCustomize.name,
        trackingService.pages.seriesCustomize.actions.shareToYammer);
    };

    $scope.getYammerEnabledStyle = function () {
      return $scope.yammerEnabled ? {} : {visibility: "hidden"};
    };

    function updateCourseShareSettings() {
      CustomizeResource.updateCourseShareSettings(
        $scope.seriesId,
        $scope.model.courseAccessType,
        $scope.yammerSharesEnabled,
        function () {
          $scope.infoChanged = false;
        });
    }

    $scope.makeDeadlineLengthValid = function () {
      $scope.courseDeadlineLengthText = $scope.courseDeadlineLength;
    };

    $scope.deadlineEnabledSettingsChanged = function () {
      var action = $scope.hasDeadlineText == 'yes' ?
        trackingService.pages.seriesCustomize.actions.completionDeadlineEnabled :
        trackingService.pages.seriesCustomize.actions.completionDeadlineDisabled;

      trackingService.trackEvent(
        trackingService.pages.seriesCustomize.name,
        action);

      $scope.deadlineSettingsChanged();
    };

    $scope.deadlineSettingsChanged = function () {
      sanitizeDeadlineSettings();
      updateDeadlineSettings();
    };

    function sanitizeDeadlineSettings() {
      $scope.hasDeadline = $scope.hasDeadlineText == 'yes';
      var num = parseInt($scope.courseDeadlineLengthText);
      if (isNaN(num)) {
        $scope.courseDeadlineLength = courseDeadlineSettings.completionDeadlineLength;
      } else {
        $scope.courseDeadlineLength = num;
        if (num <= 0)
          $scope.courseDeadlineLength = 1;
        if (num > 100)
          $scope.courseDeadlineLength = 99;
      }
      setDeadlineEditorHelpText();
    }

    function setDeadlineEditorHelpText() {
      if ($scope.hasDeadline) {
        $scope.deadlineHelpTextAfter = "Only Trainees invited after deadline is set are affected. Series deadline will override course deadlines."
      }
      else {
        $scope.deadlineHelpTextAfter = "There will be no deadline for any courses in this series."
      }
    }

    function updateDeadlineSettings() {
      courseDeadlineSettings.completionDeadlineLength = ($scope.hasDeadline ? $scope.courseDeadlineLength : 0);
      courseDeadlineSettings.completionDeadlineTimeUnit = ($scope.hasDeadline ? $scope.courseDeadlineUnit : 0);

      CustomizeResource.updateCourseDeadlineSettings(
        $scope.seriesId,
        courseDeadlineSettings.completionDeadlineLength,
        courseDeadlineSettings.completionDeadlineTimeUnit
      );
    }

    stubForNotificationPeriods();

    function stubForNotificationPeriods() {
      $scope.notificationPeriods = [
        {id: 1, name: "Instantly"},
        {id: 2, name: "Daily"},
        {id: 3, name: "Weekly"}
      ];
    }
  }

})();
